$(document).ready(function() {
  
  $('.ready-made-boxes--wrapper div').click(function() {
    $(this).siblings(".active").removeClass('active');
    $(this).addClass('active');
    $('#ready-made-boxes-next').removeAttr('disabled');
    
    if ($(this).parent().parent().attr('data-step') == 'last')
      $('#ready-made-boxes-finish').removeAttr('disabled');
  })
  
  $('.slick-arrow').click(function() {
    direction = $(this).attr('data-direction');
    parentId = $(this).parent().attr('data-step-id');
    activeElemKey = 'active-elem-' + parentId;
    
    activeElem = $(this).siblings(".ready-made-boxes--wrapper").find("." + activeElemKey);
    
    if (activeElem.length == 0)
      activeElem = $(this).siblings(".ready-made-boxes--wrapper").children(":first");
    
    nextElem = activeElem.next();
    prevElem = activeElem.prev();
    
    if (direction == 'prev') {
      if (prevElem.length) {
        activeElem.removeClass(activeElemKey);
        prevElem.addClass(activeElemKey)
        document.querySelector('.' + activeElemKey).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    } else {
      if (nextElem.length) {
        activeElem.removeClass(activeElemKey);
        nextElem.addClass(activeElemKey)
        document.querySelector('.' + activeElemKey).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
  });
  
  function step(dir) {
    currentStepId = parseInt($('.active-step').attr('data-step-id'));
    
    dirInt = (dir == 'forward') ? 1 : -1;
    nextStepId = currentStepId + dirInt;
    nextNextStepId = nextStepId + dirInt;
    
    nextStepElem = $("[data-step-id='" + nextStepId + "']");
    nextNextStepElem = $("[data-step-id='" + nextNextStepId + "']");
    
    // If the next step is the last step
    if (nextNextStepElem.length == 0 && dir == 'forward') {
      $('#ready-made-boxes-finish').show();
      $('#ready-made-boxes-back').show();
      $('#ready-made-boxes-next').hide();
      $('.active-step').removeClass('active-step').hide();
      nextStepElem.addClass('active-step').attr('data-step', 'last').show();
    
    // The next step is the first step (ie. backwards)
    } else if (nextNextStepElem.length == 0 && dir == 'backward') {
      $('#ready-made-boxes-finish').hide();
      $('#ready-made-boxes-back').hide();
      $('#ready-made-boxes-next').show();
      
      $('.active-step').removeClass('active-step').hide();
      nextStepElem.addClass('active-step').data('data-step', 'first').show();
      
    // For a middle step
    } else {
      $('#ready-made-boxes-finish').hide();
      $('#ready-made-boxes-back').show();
      $('#ready-made-boxes-next').show();
      
      $('.active-step').removeClass('active-step').hide();
      nextStepElem.addClass('active-step').data('data-step', 'first').show();
    }
          
    // If element isn't selected already for this step, then disable the next button
    if (nextStepElem.find('.active').length == 0)
      $('#ready-made-boxes-next').prop('disabled', true);
    else
      $('#ready-made-boxes-next').removeAttr('disabled');
  }
    
  $('#ready-made-boxes-next').click(function() {
    step('forward');
  })
  
  $('#ready-made-boxes-back').click(function() {
    step('backward');
  })  
  
  $('#ready-made-boxes-finish').click(function() {
    dogSize = $('[data-dog-size].active').attr('data-dog-size');
    boxSize = $('[data-box-size].active').attr('data-box-size');
    boxToy = $('[data-box-toy].active').attr('data-box-toy');
    boxChewer = $('[data-box-chewer].active').attr('data-box-chewer');
    window.location.href = '/products/chewbox-' + dogSize + '-' + boxSize + '-dog-chew?boxChewer=' + boxChewer + '&boxToy=' + boxToy;
  })  
  
});